package studio.goodegg.capsule.listen

import com.slack.circuit.runtime.CircuitUiEvent

sealed class ListenUiEvent : CircuitUiEvent {
    data object OpenInProgress : ListenUiEvent()
    data object OpenDownloads : ListenUiEvent()
}
